import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const ASPHALT = "#3f4044";
const MARKING = "#e8e6e0";

export const roadStraight = defineModel({
  id: "road-straight",
  batchId: "modern",
  name: "Road (straight)",
  tags: ["modern", "outdoor", "ground", "street", "road", "asphalt"],
  summary: "An asphalt road tile with a dashed centre line along Z.",
  description:
    "A one-tile straight road of the Modern Living kit: a 1x1 m asphalt slab " +
    "(0.06 m thick) with a white dashed centre line running along Z, so " +
    "chained tiles form a continuous dashed lane divider. Tiles seamlessly " +
    "with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: ASPHALT, position: [0, 0.03, 0] },
      // Two short dashes on the centre line; the gap pattern continues
      // across tile seams when tiles chain along Z.
      {
        geometry: new THREE.BoxGeometry(0.06, 0.012, 0.3),
        color: MARKING,
        position: [0, 0.06, -0.25],
      },
      {
        geometry: new THREE.BoxGeometry(0.06, 0.012, 0.3),
        color: MARKING,
        position: [0, 0.06, 0.25],
      },
    ];
  },
  animations: [],
});
